import * as Common from '@/tenant/common';

export class PurchaseDeliveryScheduleReportQuery extends Common.ReportQuery {
    constructor(){
        super("PurchaseDeliveryScheduleReportQuery", null);
    }
    public salesPurchaseFlag: number;
    public deliveryDateFrom: Date = null;
    public deliveryDateTo: Date = null;
    public segment: Common.Segment = null;
    public warehouse: Common.Counterpart = null;
    public noneScheduledFlag: boolean = false;
    public onExcelExport:boolean = false;           
}

export class PurchaseDeliveryScheduleReportTemplateQuery extends Common.ReportTemplateQuery {
  queryName ='PurchaseDeliveryScheduleReportQuery';
  sort = 'id';
  constructor() {
    super();
  }
}
